import { type MouseEvent, memo, useCallback } from 'react';

import { useImageContentControlsContext } from '~/components/AssetModalV2/Content/ImageContentControlsContextProvider';
import { MAX_ZOOM, MIN_ZOOM } from '~/components/AssetModalV2/Visualizer/ImageVisualizer/shared/constants';
import { ZoomSlider } from './ZoomSlider';

export const ImageZoomSlider = memo(() => {
  const {
    isMinimapAvailable,
    isMinimapOpen,
    minimapId,
    minimapToggleId,
    onToggleMinimap,
    onZoomIn,
    onZoomOut,
    updateZoom,
    zoom,
  } = useImageContentControlsContext();

  const handleSliderChange = useCallback(
    (value: number[]) => {
      const newZoom = value[0];
      updateZoom(newZoom);
    },
    [updateZoom],
  );

  const handleToggleMinimap = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      onToggleMinimap({ focusMinimap: event.detail === 0 });
    },
    [onToggleMinimap],
  );

  return (
    <ZoomSlider
      isMinimapOpen={isMinimapOpen}
      max={MAX_ZOOM}
      min={MIN_ZOOM}
      minimapControlsId={minimapId}
      minimapToggleId={minimapToggleId}
      onSliderChange={handleSliderChange}
      onToggleMinimap={isMinimapAvailable ? handleToggleMinimap : undefined}
      onZoomIn={onZoomIn}
      onZoomOut={onZoomOut}
      step={0.1}
      zoom={zoom}
    />
  );
});

ImageZoomSlider.displayName = 'ImageZoomSlider';
